module.exports = __webpack_public_path__ + "static/media/UniNeueBook-Italic.8106533d.woff";